import * as Yup from "yup";

export const notificationsInactiveSchema = Yup.object().shape({
  title: Yup.string()
    .transform((v) => (typeof v === "string" ? v.trim() : v))
    .optional(),
  inactive_days: Yup.number()
    .required("Dias de inatividade é obrigatório")
    .integer("Deve ser inteiro")
    .min(1, "Deve ser >= 1"),
  message_with_subscription: Yup.string()
    .required("Mensagem (com assinatura) é obrigatória")
    .max(500, "Mensagem deve ter no máximo 500 caracteres"),
  message_without_subscription: Yup.string()
    .required("Mensagem (sem assinatura) é obrigatória")
    .max(500, "Mensagem deve ter no máximo 500 caracteres"),
  active: Yup.boolean().required(),
});
